import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCxyEVHboqOjh9bxGneTGvjtE5UOvd-BHs",
  authDomain: "beetech-cf701.firebaseapp.com",
  projectId: "beetech-cf701",
  storageBucket: "beetech-cf701.appspot.com",
  messagingSenderId: "652560921061",
  appId: "1:652560921061:web:0e4ddff70d375f799abf0c",
  measurementId: "G-WXQH44TH1B",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
